import style from "../style/Loading.module.css"

export default function Loading() {
  return (
    <div className={style["loader"]}></div>
  
  );
}
